import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import moment from "moment";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoEscaneos() {
  const { user } = useContext(AuthContext);
  const URL_ESCANEOS = import.meta.env.VITE_URL_ESCANEOS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_ARTICULOS_ESCANEADOS =
    import.meta.env.VITE_URL_ARTICULOS_ESCANEADOS;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;

  const [escaneos, setEscaneos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [modal, setModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [modalMail, setModalMail] = useState(false);
  const [mailTo, setMailTo] = useState("");

  // Form state
  const [nombre, setNombre] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [fecha, setFecha] = useState("");
  const [idEdit, setIdEdit] = useState("");

  // Report state
  const [reportData, setReportData] = useState([]);
  const [currentEscaneo, setCurrentEscaneo] = useState(null);

  // Pagination state
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [selectedAreaFiltro, setSelectedAreaFiltro] = useState("");

  const ITEMS_PER_PAGE = 50;

  const toggle = () => setModal(!modal);
  const toggleReport = () => setReportModal(!reportModal);
  const toggleMail = () => setModalMail(!modalMail);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    showLoader();

    // Load escaneos
    axios
      .get(URL_ESCANEOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEscaneos = response.data;
        setEscaneos(allEscaneos);
        setComments(allEscaneos);
        hideLoader();
      })
      .catch((err) => {
        console.log(err);
        hideLoader();
      });

    // Load areas
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function editEscaneo(event) {
    event.preventDefault();
    const URL_ESCANEOS_EDIT = `${URL_ESCANEOS}/${idEdit}`;
    axios
      .patch(
        URL_ESCANEOS_EDIT,
        {
          name: nombre,
          areas: selectedAreas,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Escaneo",
            detalle: nombre,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
            window.location.reload();
          }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(escaneo) {
    setNombre(escaneo.name);
    setSelectedAreas(
      escaneo.areas.map((area) => (typeof area === "string" ? area : area._id))
    );
    setFecha(moment(escaneo.createdAt).format("YYYY-MM-DD"));
    setIdEdit(escaneo._id);
    toggle();
  }

  function finishEscaneo(escaneoId) {
    Swal.fire({
      title: "¿Finalizar escaneo?",
      text: "Esto marcará el escaneo como completado. ¿Desea continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, finalizar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ESCANEOS}/${escaneoId}`,
            {
              estado: "Cerrado",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            Swal.fire(
              "¡Finalizado!",
              "El escaneo ha sido finalizado correctamente.",
              "success"
            );
            setTimeout(() => {
                window.location.reload();
              }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "No se pudo finalizar el escaneo",
              footer: error.response ? (error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado') : error.message,
            });
          });
      }
    });
  }

  function compareInventory(escaneo) {
    setCurrentEscaneo(escaneo);
    let escaneoData = commentsData.filter((e) => e._id === escaneo._id);
    console.log(escaneoData);
      if (escaneoData[0].estado === "No") {
        Swal.fire({
          icon: "warning",
          title: "Escaneo no cerrado",
          text: "No se puede comparar un escaneo sin cerrar",
        });
      }
     else {
      axios
        .get(
          `${URL_ARTICULOS_ESCANEADOS}/reporteArticulosEscaneadosByEscaneo/${escaneo._id}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          setReportData(response.data);
          toggleReport();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo cargar el reporte de inventario",
            footer: error.response ? (error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado') : error.message,
          });
        });
    }
  }

  function PDFTabla() {
    let total_escaneado = 0;

    const data = commentsData.map((e) => {
      const areasString =
        e.areas && e.areas.length > 0
          ? e.areas
              .map((area) =>
                typeof area === "string"
                  ? areas.find((a) => a._id === area)?.name ||
                    "Área desconocida"
                  : area.name
              )
              .join(", ")
          : "Sin áreas asignadas";

      total_escaneado += e.totalEscaneado || 0;

      return [
        e.name,
        areasString,
        moment(e.createdAt).format("DD/MM/YYYY HH:mm"),
        e.estado || "Activo",
        e.totalEscaneado || 0,
      ];
    });

    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado de Escaneos`, 20, 40);
    doc.autoTable({
      head: [["Nombre", "Áreas", "Fecha", "Estado", "Total Escaneado"]],
      body: data,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total_escaneado),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`ListadoEscaneos.pdf`);
  }

  function excel() {
    const dataExcel = commentsData.map((e) => {
      const areasString =
        e.areas && e.areas.length > 0
          ? e.areas
              .map((area) =>
                typeof area === "string"
                  ? areas.find((a) => a._id === area)?.name ||
                    "Área desconocida"
                  : area.name
              )
              .join(", ")
          : "Sin áreas asignadas";

      return {
        Nombre: e.name,
        Areas: areasString,
        Fecha: moment(e.createdAt).format("DD/MM/YYYY HH:mm"),
        Estado: e.estado || "Activo",
        TotalEscaneado: e.totalEscaneado || 0,
      };
    });

    var option = {};

    option.fileName = "ListadoEscaneos";

    option.datas = [
      {
        sheetData: dataExcel,
        sheetName: "ListadoEscaneos",
        sheetFilter: ["Nombre", "Areas", "Fecha", "Estado", "TotalEscaneado"],
        sheetHeader: ["Nombre", "Áreas", "Fecha", "Estado", "Total Escaneado"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total_escaneado = 0;

    const data = commentsData.map((e) => {
      const areasString =
        e.areas && e.areas.length > 0
          ? e.areas
              .map((area) =>
                typeof area === "string"
                  ? areas.find((a) => a._id === area)?.name ||
                    "Área desconocida"
                  : area.name
              )
              .join(", ")
          : "Sin áreas asignadas";

      total_escaneado += e.totalEscaneado || 0;

      return [
        e.name,
        areasString,
        moment(e.createdAt).format("DD/MM/YYYY HH:mm"),
        e.estado || "Activo",
        e.totalEscaneado || 0,
      ];
    });

    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado de Escaneos`, 20, 40);
    doc.autoTable({
      head: [["Nombre", "Áreas", "Fecha", "Cerrado", "Total Escaneado"]],
      body: data,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total_escaneado),
        ],
      ],
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Escaneos",
          email: mailTo,
          fileName: "ListadoEscaneos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Escaneos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }
  // Export the report data as CSV
  function exportToExcel() {
    if (!reportData || reportData.length === 0 || !currentEscaneo) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No hay datos para exportar",
      });
      return;
    }
  
    // Prepare data for Excel export
    const dataExcel = reportData.map((item) => {
      return {
        Codigo: item.codigo,
        Articulo: item.descripcion,
        Color: item.color,
        Talla: item.talla,
        CantidadEscaneada: item.totalCantidad,
        InventarioActual: item.inventarioActual,
        Diferencia: item.diferencia
      };
    });
  
    // Calculate totals
    const totalEscaneado = reportData.reduce(
      (sum, item) => sum + item.totalCantidad,
      0
    );
    const totalInventario = reportData.reduce(
      (sum, item) => sum + item.inventarioActual,
      0
    );
    const totalDiferencia = reportData.reduce(
      (sum, item) => sum + item.diferencia,
      0
    );
  
    // Add totals row
    dataExcel.push({
      Codigo: "TOTALES",
      Articulo: "",
      Color: "",
      Talla: "",
      CantidadEscaneada: totalEscaneado,
      InventarioActual: totalInventario,
      Diferencia: totalDiferencia
    });
  
    // Configure Excel export options
    var option = {};
  
    option.fileName = `REPORTE-ESCANEO-${currentEscaneo.name}`;
  
    option.datas = [
      {
        sheetData: dataExcel,
        sheetName: "ReporteInventario",
        sheetFilter: [
          "Codigo", 
          "Articulo", 
          "Color", 
          "Talla", 
          "CantidadEscaneada", 
          "InventarioActual", 
          "Diferencia"
        ],
        sheetHeader: [
          "Código", 
          "Artículo", 
          "Color", 
          "Talla", 
          "Cantidad Escaneada", 
          "Inventario Actual", 
          "Diferencia"
        ],
      },
    ];
  
    // Create and trigger the Excel download
    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  // Table header configuration
  const headers = [
    { name: "Nombre", field: "name", sortable: true },
    { name: "Áreas", field: "areas", sortable: false },
    { name: "Fecha", field: "createdAt", sortable: true },
    { name: "Cerrado", field: "estado", sortable: true },
    { name: "Acciones", field: "actions", sortable: false },
  ];

  // Filter and paginate the data
  const commentsData = useMemo(() => {
    let computedComments = escaneos;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          (comment.name &&
            comment.name.toLowerCase().includes(search.toLowerCase())) ||
          (comment.estado &&
            comment.estado.toLowerCase().includes(search.toLowerCase())) ||
          (comment.createdAt &&
            moment(comment.createdAt).format("DD/MM/YYYY").includes(search))
      );
    }

    if (selectedAreaFiltro) {
      computedComments = computedComments.filter(
        (e) =>
          e.areas &&
          e.areas.some(
            (area) =>
              (typeof area === "string" ? area : area._id) ===
              selectedAreaFiltro
          )
      );
    }

    setTotalItems(computedComments.length);

    // Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;

      if (sorting.field === "createdAt") {
        computedComments = computedComments.sort(
          (a, b) => reversed * (new Date(a.createdAt) - new Date(b.createdAt))
        );
      } else {
        computedComments = computedComments.sort(
          (a, b) =>
            reversed *
            (a[sorting.field]
              ? a[sorting.field].localeCompare(b[sorting.field] || "")
              : 0)
        );
      }
    }

    // Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [escaneos, currentPage, search, sorting, selectedAreaFiltro]);

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        {user.inventariosTiendas ? (
          <div className="row">
            <div className="card col-12">
              <Row>
                <Col md={8}>
                  <Button
                    size="sm"
                    href="/EscaneoTiendas"
                    className="btn btn-primary"
                    id="botonListado"
                    color="success"
                  >
                    Nuevo Escaneo
                  </Button>
                  <Button
                    size="sm"
                    href="/MenuTiendas"
                    className="btn btn-danger ml-2"
                    id="botonListado"
                    color="danger"
                  >
                    Regresar
                  </Button>
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i className="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i className="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i className="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>

              <h3 align="center">Inventario Físico</h3>

              <div className="row">
                <div className="col-md-10">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-2 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <br />

              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <thead>
                  <tr>
                    <td style={{ paddingTop: "0px" }}>
                      <Input
                        bsSize="sm"
                        type="text"
                        placeholder="Buscar por nombre..."
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setCurrentPage(1);
                        }}
                      />
                    </td>
                    <td style={{ paddingTop: "0px" }}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={selectedAreaFiltro}
                        onChange={(e) => {
                          setSelectedAreaFiltro(e.target.value);
                          setCurrentPage(1);
                        }}
                      >
                        <option value="">Todas las áreas</option>
                        {areas
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            return (
                              <option key={a._id} value={a._id}>
                                {a.name}
                              </option>
                            );
                          })}
                      </Input>
                    </td>
                    <td style={{ paddingTop: "0px" }}></td>
                    <td style={{ paddingTop: "0px" }}></td>
                    <td style={{ paddingTop: "0px" }}></td>
                  </tr>
                </thead>
                <tbody>
                  {commentsData
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )
                    .map((e) => {
                      return (
                        <tr key={e._id}>
                          <td>{e.name}</td>
                          <td>
                            {e.areas && e.areas.length > 0
                              ? e.areas
                                  .map((area) =>
                                    typeof area === "string"
                                      ? areas.find((a) => a._id === area)
                                          ?.name || "Área desconocida"
                                      : area.name
                                  )
                                  .join(", ")
                              : "Sin áreas asignadas"}
                          </td>
                          <td>
                            {moment(e.createdAt).format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td>{e.estado || "Activo"}</td>
                          <td>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              className="mr-1"
                              onClick={() => jalaInfo(e)}
                            >
                              <i className="far fa-edit"></i>{" "}
                            </Button>

                            {(!e.estado || e.estado !== "Cerrado") && (
                              <Button
                                color="warning"
                                id="Finalizar"
                                size="sm"
                                className="mr-1"
                                onClick={() => finishEscaneo(e._id)}
                              >
                                <i className="fas fa-check-circle"></i>{" "}
                              </Button>
                            )}

                            <Button
                              color="success"
                              id="Comparar"
                              size="sm"
                              onClick={() => compareInventory(e)}
                            >
                              <i className="fas fa-balance-scale"></i>{" "}
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </div>
          </div>
        ) : undefined}
      </div>

      {/* Modals */}
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Escaneo</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12 mb-3"
            type="text"
            value={nombre}
            required
            onChange={(e) => {
              setNombre(e.target.value);
            }}
          />
          <Label className="mr-sm-2">Áreas</Label>
          <Input
            className="col-sm-12 mb-3"
            type="select"
            
            value={selectedAreas}
            disabled
          >
            {areas.map((area) => (
              <option key={area._id} value={area._id}>
                {area.name}
              </option>
            ))}
          </Input>
          <Label className="mr-sm-2">Fecha de Creación</Label>
          <Input className="col-sm-12" type="text" value={fecha} disabled />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEscaneo}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={reportModal} toggle={toggleReport}>
        <ModalHeader toggle={toggleReport}>
          Comparación de Inventario - {currentEscaneo && currentEscaneo.name}
        </ModalHeader>
        <ModalBody>
          {reportData.length > 0 ? (
            <>
              <div className="mb-3 text-right">
                <Button color="primary" onClick={exportToExcel}>
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </div>

              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <thead>
                  <tr>
                    <th className="tituloTabla">Código</th>
                    <th className="tituloTabla">Artículo</th>
                    <th className="tituloTabla">Color</th>
                    <th className="tituloTabla">Talla</th>
                    <th className="tituloTabla">Cantidad Escaneada</th>
                    <th className="tituloTabla">Inventario Actual</th>
                    <th className="tituloTabla">Diferencia</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.codigo}</td>
                      <td>{item.descripcion}</td>
                      <td>{item.color}</td>
                      <td>{item.talla}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          item.totalCantidad
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          item.inventarioActual
                        )}
                      </td>
                      <td
                        className={
                          item.diferencia !== 0
                            ? item.diferencia > 0
                              ? "text-success"
                              : "text-danger"
                            : ""
                        }
                      >
                        {new Intl.NumberFormat("en-US").format(item.diferencia)}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4} className="text-right">
                      <strong>TOTALES:</strong>
                    </td>
                    <td>
                      <strong>
                        {new Intl.NumberFormat("en-US").format(
                          reportData.reduce(
                            (sum, item) => sum + item.totalCantidad,
                            0
                          )
                        )}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {new Intl.NumberFormat("en-US").format(
                          reportData.reduce(
                            (sum, item) => sum + item.inventarioActual,
                            0
                          )
                        )}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {new Intl.NumberFormat("en-US").format(
                          reportData.reduce(
                            (sum, item) => sum + item.diferencia,
                            0
                          )
                        )}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </>
          ) : (
            <div className="text-center p-5">
              <p>No hay datos disponibles para este escaneo.</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleReport}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Listado de Escaneos</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoEscaneos;
